import axios from "axios";
import * as Sentry from "@sentry/react";
import { environment } from "../../environments/environment";
import { safePathSegment } from "../../utils/safePathSegment";

export class RegisterService {
  async getAddressFromCep(cep) {
    const cepLimpo = cep.replace(/\D/g, "");

    try {
      const url = `${environment.endpoints.base_api_url}/api/v2/zipcode/${safePathSegment(cepLimpo)}`;

      const response = await axios.get(url, {
        headers: {},
      });

      const apiData = response.data.data;

      return {
        data: {
          cep: apiData.cep || "",
          logradouro: apiData.logradouro || "",
          bairro: apiData.bairro || "",
          localidade: apiData.cidade || "",
          uf: apiData.estado || "",
          ibge: apiData.codigo_ibge || ""
        },
        erro: false,
      };
    } catch (e) {
      Sentry.captureException(e);
      return { data: { erro: true } };
    }
  }

  async registerUser(data, id) {
    return await axios.post(
      `${environment.endpoints.base_api_url}/api/v2/payment/register/${safePathSegment(id)}`,
      data,
      {
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      }
    );
  }
}

export default new RegisterService();
